import VaccinationEligibilityBlock from './VaccinationEligibilityBlock';
import ButtonBlock from './ButtonBlock';

export { ButtonBlock };
export default VaccinationEligibilityBlock;
